import React from 'react';
export function UniqueMechanism() {
  return <section className="py-[20px] px-0 bg-white" data-id="element-267">
      <div className="container max-w-full mx-auto px-[15px]" data-id="element-268">
        <h2 className="text-[24px] text-center mb-[20px] font-[700] text-[#111827] font-['Montserrat']" data-id="element-269">
          🧠 MECANISMO ÚNICO — MÉTODO BÍBLICO™
        </h2>
        <img src="https://app.heylloyd.io/public/files/openrouter-generated-image-1770584581335.png" alt="Método Bíblico" className="w-full rounded-[8px] block" data-id="element-270" />
      </div>
    </section>;
}